import { render, staticRenderFns } from "./gruposQuicktable.vue?vue&type=template&id=42aa0857&"
import script from "./gruposQuicktable.vue?vue&type=script&lang=js&"
export * from "./gruposQuicktable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports